(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("knockout"), require("jquery"));
	else if(typeof define === 'function' && define.amd)
		define(["knockout", "jquery"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("knockout"), require("jquery")) : factory(root["ko"], root["$"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_49__, __WEBPACK_EXTERNAL_MODULE_50__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition